exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n* The following styles are auto-applied to elements with\n* transition=\"page-transition\" when their visibility is toggled\n* by Vue.js.\n*\n* You can easily play with the page transition by editing\n* these styles.\n*/\n.page-transition-enter {\n  opacity: 0;\n}\n.page-transition-leave-active {\n  opacity: 0;\n}\n.page-transition-enter .page-transition-container,\n.page-transition-leave-active .page-transition-container {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n", ""]);

// exports
